var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2453",
    "data-name": "Group 2453",
    transform: "translate(-8 -44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2454",
    "data-name": "Group 2454",
    transform: "translate(8 44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8175",
    "data-name": "Path 8175",
    d: "M19.556,0H2.444A2.624,2.624,0,0,0,0,2.768v12.69a2.624,2.624,0,0,0,2.444,2.768h.028a.542.542,0,0,1,.505.572V22l3.717-3.636a.472.472,0,0,1,.33-.139H19.556A2.624,2.624,0,0,0,22,15.457V2.768A2.624,2.624,0,0,0,19.556,0M6.3,10.523A1.258,1.258,0,0,1,5.132,9.2,1.258,1.258,0,0,1,6.3,7.869,1.258,1.258,0,0,1,7.475,9.2,1.258,1.258,0,0,1,6.3,10.523m4.7,0A1.258,1.258,0,0,1,9.828,9.2,1.258,1.258,0,0,1,11,7.869,1.258,1.258,0,0,1,12.172,9.2,1.258,1.258,0,0,1,11,10.523m4.7,0A1.258,1.258,0,0,1,14.525,9.2,1.258,1.258,0,0,1,15.7,7.869,1.258,1.258,0,0,1,16.868,9.2,1.258,1.258,0,0,1,15.7,10.523",
    fill: "#22c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.53e783c3ca5f17a09300fca6cbcc0407.svg";
export { ForwardRef as ReactComponent };